import styles from './VitalSignsTab.module.css';

function VitalSignResults({
  label,
  value,
  unit,
}: {
  label: string;
  value: number | string;
  unit: string;
}) {
  return (
    <div className={styles.vitalSignResult}>
      <p className={styles.label}>{label}</p>
      <p className={styles.value}>
        {value} {value && <span>{unit}</span>}
      </p>
    </div>
  );
}

export default VitalSignResults;
